export default {
  en: {
    'pages.fix-errors-page.entity-header': 'Resolve issues',
    'pages.fix-errors-page.heading.error': 'Error: ',
    'pages.fix-errors-page.heading.warning': 'Warning: ',
    'pages.fix-errors-page.actions.ignore-all': 'Ignore all',
    'pages.fix-errors-page.actions.remove-all': 'Remove all',
    'pages.fix-errors-page.filter-dropdown-text': 'Filter',
    'pages.fix-errors-page.filter-dropdown-on': 'ON',
  },
};
